var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-container",class:_vm.className},[_c('div',{staticClass:"xl:w-3/12 lg:w-4/12 md:w-6/12 sm:w-9/12 mt-5 mx-auto"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }